import { DomainUpsert } from "@/components/domain";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { CreateDepartment } from "@/models";
import { FormOptions } from "@deadcow-enterprises/react-forms";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { z } from "zod";

export function Form({
  model,
  onUpsert,
}: {
  model?: CreateDepartment;
  onUpsert: (data: CreateDepartment) => Promise<void>;
}) {
  const { t } = useTranslation();
  const isEdit = useMemo(() => !!model, [model]);
  const formConfig = useMemo<FormOptions<CreateDepartment>>(() => {
    const config: FormOptions<CreateDepartment> = {
      name: {
        value: model?.name ?? "",
        validator: z.string().min(1, "errors.required"),
      },
      description: {
        value: model?.description ?? "",
      },
    };
    return config;
  }, [model]);

  return (
    <DomainUpsert
      title={model?.name ?? t("departments.new.title")}
      buttonTranslation={
        isEdit ? "departments.update.button" : "departments.new.button"
      }
      formConfig={formConfig}
      onUpsert={onUpsert}
      fields={[
        {
          key: "name",
          label: "departments.fields.name",
          input: (form, id) => (
            <Input
              id={id}
              value={form.value.name}
              onChange={(ev) => {
                form.setValue("name", ev.target.value);
              }}
            />
          ),
        },
        {
          key: "description",
          label: "departments.fields.description",
          input: (form, id) => (
            <Textarea
              className="w-full"
              id={id}
              value={form.value.description ?? ""}
              onChange={(ev) => {
                form.setValue("description", ev.target.value);
              }}
            />
          ),
        },
      ]}
    />
  );
}
